import {takeEvery} from 'redux-saga/effects'
import {
  GENERATE_CAIE_STATISTICS,
  GENERATE_COMPREHENSIVE_REPORT,
  GET_CAIE_STATISTICS_FILTERS,
  GET_CHART_DATA,
  GET_COMPREHENSIVE_REPORT_FILTERS,
  GET_REPORT_FILTERS_DATA,
  GET_SETTINGS,
  GET_SIGNATURE_UPLOAD_URL,
  UPDATE_SETTINGS,
} from 'setup/redux/Actions/School/PerformanceReports/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_CHART_DATA, fetchData)
  yield takeEvery(GET_REPORT_FILTERS_DATA, fetchData)
  yield takeEvery(GET_SETTINGS, fetchData)
  yield takeEvery(GET_SIGNATURE_UPLOAD_URL, fetchData)
  yield takeEvery(UPDATE_SETTINGS, fetchData)
  yield takeEvery(GET_COMPREHENSIVE_REPORT_FILTERS, fetchData)
  yield takeEvery(GENERATE_COMPREHENSIVE_REPORT, fetchData)
  yield takeEvery(GET_CAIE_STATISTICS_FILTERS, fetchData)
  yield takeEvery(GENERATE_CAIE_STATISTICS, fetchData)
}

export default dataSaga
